import React, { Component } from 'react';
import '../../Modal.css';
import { raspberrypi } from '../../../../apis/backend';
import { connect } from 'react-redux';

class EditModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mac: '',
      nickname: '',
      location: ''
    };
  }

  clearState() {
    this.setState({
      mac: '',
      nickname: '',
      location: ''
    });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      prevProps.selectedScanner !== this.props.selectedScanner &&
      this.props.selectedSCanner !== 0
    ) {
      const scanner = this.props.scanners.find((obj) => obj.id === this.props.selectedScanner);
      if (scanner) {
        this.setState({
          mac: scanner.mac,
          nickname: scanner.nickname,
          location: scanner.location
        });
      }
    }
  }

  async scannerRequest() {
    try {
      await raspberrypi
        .patch(
          `/${this.props.selectedScanner}`,
          {
            mac: this.state.mac,
            nickname: this.state.nickname,
            location: this.state.location
          },
          { headers: { authorization: this.props.employeeToken } }
        )
        .then(this.clearState())
        .catch((response) => {
          console.log(response);
          alert('Sorry, an error occurred. Please check your entries.');
        });
    } catch (err) {
      console.log('Request Failed.');
    }
  }

  render() {
    return (
      <div id="editModal" className="modal fade" style={{ overflow: 'scroll' }}>
        <div className="modal-dialog modal-dialog-centered lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit Scanner</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="input-group input-group-sm mb-3">
                <div className="input-group-prepend">
                  <span className="input-group-text" id="inputGroup-sizing-sm">
                    Name
                  </span>
                </div>
                <input
                  type="text"
                  className="form-control"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  value={this.state.nickname}
                  placeholder="Name"
                  onChange={(e) => this.setState({ nickname: e.target.value })}
                />
              </div>
              {/* <div className="input-group input-group-sm mb-3">
                <div className="input-group-prepend">
                  <span className="input-group-text" id="inputGroup-sizing-sm">
                    MAC
                  </span>
                </div>
                <input
                  type="text"
                  className="form-control"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  value={this.state.mac}
                  placeholder="MAC"
                  onChange={(e) => this.setState({ mac: e.target.value })}
                />
              </div> */}
              <div className="input-group input-group-sm mb-3">
                <div className="input-group-prepend">
                  <span className="input-group-text" id="inputGroup-sizing-sm">
                    Location
                  </span>
                </div>
                <select
                  className="form-control"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  value={this.state.location}
                  onChange={(e) => {
                    this.setState({ location: e.target.value });
                  }}
                >
                  {/* <option value="" disabled>
                    Select Location
                  </option> */}
                  {this.props.systemLocations.map((location) => (
                    <option key={location.id} value={location.id}>
                      {location.location}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
                onClick={() => this.clearState()}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-dark"
                data-dismiss="modal"
                onClick={() => {
                  this.scannerRequest();
                }}
                disabled={!(this.state.nickname !== '' && this.state.location !== '')}
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  scanners: state.admin.admin.raspberryPis,
  selectedScanner: state.admin.scanners.selectedScanner,
  systemLocations: state.admin.admin.systemLocations,
  employeeToken: state.auth.employeeToken
});

export default connect(mapStateToProps, {})(EditModal);
